import { Component } from '@angular/core';

@Component({
  selector: 'lib-survey-expired',
  imports: [],
  templateUrl: './survey-expired.html',
  styleUrl: './survey-expired.css',
})
export class SurveyExpired {

}
